import React from "react";
import classes from "./Labeled.module.css";
import globalStyles from "../../../styles/styles.module.css";

type LabeledProps = {
    label: string;
    id: string;
    small?: string;
    extraClasses?: string;
};

const Labeled: React.FC<LabeledProps> = (props) => {
    return (
        <div className={[classes.Labeled, props.extraClasses].join(" ")}>
            <label htmlFor={props.id} className={globalStyles.noselect}>
                {props.label}
            </label>
            {props.children}
            {props.small ? <small className={globalStyles.noselect}>{props.small}</small> : null}
        </div>
    );
};

export default Labeled;
